// Simple Cookie Consent Implementation
(function() {
  'use strict';
  
  // Check if user has already consented
  function hasConsented() {
    return localStorage.getItem('cookieConsent') === 'accepted';
  }
  
  // Set consent status
  function setConsent() {
    localStorage.setItem('cookieConsent', 'accepted');
    hideBanner();
  }
  
  // Hide the banner
  function hideBanner() {
    const banner = document.querySelector('.cc-window.cc-banner');
    if (banner) {
      banner.style.display = 'none';
    }
  }
  
  // Create the cookie banner HTML
  function createBanner() {
    const banner = document.createElement('div');
    banner.className = 'cc-window cc-banner cc-bottom cc-type-info cc-theme-block cookies_style_2';
    banner.innerHTML = `
      <div class="cc-message-wrapper">
        <span class="cc-message">By using this site you agree to our use of cookies.</span>
        <a href="/pages/privacy-policy" class="cc-link">Read more.</a>
      </div>
      <span class="cc-customClose" aria-label="dismiss cookie message">&times;</span>
      <div class="opt_out">opt out</div>
    `;
    
    document.body.appendChild(banner);
    
    // Add event listeners
    const closeBtn = banner.querySelector('.cc-customClose');
    const optOutBtn = banner.querySelector('.opt_out');
    
    if (closeBtn) {
      closeBtn.addEventListener('click', setConsent);
    }
    if (optOutBtn) {
      optOutBtn.addEventListener('click', setConsent);
    }
  }
  
  // Initialize cookie consent
  function init() {
    if (!hasConsented()) {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', createBanner);
      } else {
        createBanner();
      }
    }
  }
  
  // Start the cookie consent
  init();
  
})();